import './rateTrip.css';
import ReviewStars from '../reviewStars/ReviewStars';

const RateTrip = ({ props }) => {
    const { popupRating, setPopupRating, comment, setComment } = props;
    const maxChars = 300;

    return (
        <div className='rate-trip-container'>
            <div style={{ marginTop: '20px', fontSize: '16px', fontWeight: '600' }}>Overall Feedback</div>
            <div className='star-rating'>
                {/* <label className='label' htmlFor='rating-stars'>
                    Rate your trip:
                </label> */}
                <ReviewStars rating={popupRating} onRatingChange={setPopupRating} isInteractive />
            </div>

            <div className='comment-section'>
                <label className='label' htmlFor='commentBox'>
                    Type your review:
                </label>
                <textarea
                    id='commentBox'
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    placeholder='Type your review here...'
                    className='comment-box'
                    maxLength={maxChars}
                    rows={4}
                />
                <div className='char-count'>
                    {comment.length}/{maxChars} characters
                </div>
            </div>
        </div>
    );
};

export default RateTrip;
